<!-- START Top Navbar -->
<nav class="navbar topnavbar" role="navigation">
  <!-- Mobile Layout -->
  <div class="d-flex d-md-none w-100 justify-content-between align-items-center px-3 py-2 bg-primary text-white">
    <!-- Menu Toggle -->
    <a class="nav-link text-white" (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
      <em class="fas fa-bars"></em>
    </a>

    <!-- Logo -->
    <a class="navbar-brand mx-auto" href="#/">
      <div class="brand-logo d-flex align-items-center">
        <img class="logo" src="/assets/img/logo.png" alt="Logo" />
        <img class="solimarket ms-2" src="/assets/img/solimarket.png" alt="SoliMarket" />
      </div>
    </a>

    <!-- Logout -->
    <a class="nav-link text-white" (click)="logout()" title="Logout">
      <em class="bi bi-box-arrow-in-left"></em>
    </a>
  </div>

  <!-- Desktop/Tablet Layout -->
  <div class="d-none d-md-flex w-100 align-items-center justify-content-between px-3">
    <!-- Sidebar Toggle -->
    <ul class="navbar-nav flex-row">
      <li class="nav-item">
        <a class="nav-link" trigger-resize (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
          <em class="fas fa-bars"></em>
        </a>
      </li>
    </ul>

    <!-- Logo Section -->
    <div class="navbar-header mx-auto">
      <a class="navbar-brand" href="#/">
        <ng-container *ngIf="!isCollapsedText(); else collapsedLogo">
          <div class="brand-logo d-flex align-items-center">
            <img class="logo" src="/assets/img/logo.png" alt="Logo" />
            <img class="solimarket ms-2" src="/assets/img/solimarket.png" alt="SoliMarket" />
          </div>
        </ng-container>
        <ng-template #collapsedLogo>
          <div class="brand-logo-collapsed">
            <img src="/assets/img/logo.png" alt="Collapsed Logo" />
          </div>
        </ng-template>
      </a>
    </div>

    <!-- Balance Section -->
    <div class="flex-grow-1 d-flex justify-content-center">
      <ul class="navbar-nav flex-row" *ngIf="issuingEntity && user.isInRole('AgencyUser') && benefits?.length">
        <li class="nav-item brand-logo-collapsed" *ngFor="let item of benefits; let i = index">
          <span *ngIf="item.active">
            <span *ngIf="i > 0" class="mx-2">|</span>
            {{ item.benefitName }} Balance : ${{ item.fundsAvailable | number : "1.0-2" }}
          </span>
        </li>
      </ul>
    </div>

    <!-- Right Section: Agency + Profile + Logout -->
    <ul class="navbar-nav flex-row ms-auto">
      <li class="nav-item d-none d-md-block">
        <a *ngIf="issuingEntity && user.issuingEntites.length > 1 && user.isInRole('AgencyUser')"
           class="nav-link" (click)="changeIssuingEntity()" title="Agency">
          <span class="entity">{{ issuingEntity.name }}</span>
          <em class="bi bi-arrow-left-right"></em>
        </a>
        <label *ngIf="user.issuingEntites.length === 1" class="nav-link">
          <span class="entity">{{ user.issuingEntites[0].name }}</span>
        </label>
      </li>
      <li class="nav-item d-none d-md-block">
        <a class="nav-link" [routerLink]="'/users/profile'" title="Profile">
          <em class="bi bi-person"></em>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-white" (click)="logout()" title="Logout">
          <em class="bi bi-box-arrow-in-left"></em>
        </a>
      </li>
    </ul>
  </div>
</nav>
<!-- END Top Navbar -->

<!-- Modal Template for Selecting Issuing Entity -->
<ng-template #selectIssuingEntity let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Select Agency</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-select-issuing-entity (refresh)="onRefresh($event)"></app-select-issuing-entity>
  </div>
</ng-template>
